export const environments = {
    domain: window.location.hostname === 'localhost' ? 'http://localhost:8000' : 'https://library-backend.ky4trb.easypanel.host',
    tokenKey: 'D-CIU-Admin',
    themeSelected: 'themeSelected',
    colorSchemeSelected: 'colorSchemeSelected',
    uiMode: "chakra-ui-color-mode",
}
